import yup from 'yup';
import { documentOffsetTop } from '../utils/helpers';

/**
 * Schemas for forms
 */
const generalDetails = {
  category: yup.string().required(),
  horseFeiId: yup.string(),
  horseName: yup.string().required(),
  lungerFeiId: yup.string(),
  lungerFirstName: yup.string().required(),
  lungerLastName: yup.string().required(),
  notes: yup.string(),
};

const vaulter = {
  vaulterFeiId: yup.string(),
  vaulterFirstName: yup.string().required(),
  vaulterLastName: yup.string().required(),
  vaulterGender: yup.string().required(),
  vaulterDateOfBirth: yup.string().required(),
};

const schemas = {
  loginCredentials: yup.object().shape({
    nation: yup
      .string()
      .max(3)
      .max(5)
      .required(),
    password: yup
      .string()
      .min(8)
      .max(8)
      .required(),
  }),

  userData: yup.object().shape({
    nation: yup
      .string()
      .min(3)
      .max(3)
      .required(),
    isAdmin: yup.boolean().required(),
  }),

  entryData: yup.object().shape({
    nation: yup
      .string()
      .min(3)
      .max(3)
      .required(),
    competition: yup.string().required(),
    details: yup.object().required(),
  }),

  horseData: yup.object().shape({
    nation: yup
      .string()
      .min(3)
      .max(3)
      .required(),
    details: yup.object().required(),
  }),

  horseDetails: yup.object().shape({
    horseFeiId: yup.string(),
    horseName: yup.string().required(),
  }),

  individualsDetails: yup.object().shape(Object.assign({}, generalDetails, vaulter)),

  pasDeDeuxDetails: yup.object().shape(
    Object.assign({}, generalDetails, {
      firstVaulterFeiId: yup.string(),
      firstVaulterFirstName: yup.string().required(),
      firstVaulterLastName: yup.string().required(),
      firstVaulterGender: yup.string().required(),
      firstVaulterDateOfBirth: yup.string().required(),
      secondVaulterFeiId: yup.string(),
      secondVaulterFirstName: yup.string().required(),
      secondVaulterLastName: yup.string().required(),
      secondVaulterGender: yup.string().required(),
      secondVaulterDateOfBirth: yup.string().required(),
    })
  ),

  squadDetails: yup.object().shape(
    Object.assign({}, generalDetails, {
      squadName: yup.string().required(),
      vaulters: yup
        .array()
        .of(yup.object().shape(Object.assign({}, vaulter)))
        .required(),
    })
  ),
};

const formatError = err => {
  const arr = err.split(' ');

  const arrField = arr[0].split('.');

  let label = arrField[arrField.length - 1];

  label = label.replace(/([A-Z])/g, ' $1');
  label = label.charAt(0).toUpperCase() + label.slice(1);

  arr[0] = label;

  return arr.join(' ');
};

const validateObject = (obj, schema) =>
  new Promise(resolve => {
    const opts = {
      abortEarly: false,
    };

    schema
      .validate(obj, opts)
      .then(() => {
        resolve([]);
      })
      .catch(res => {
        const fields = [];

        const formatedErrors = res.inner.filter(err => {
          if (!fields.includes(err)) {
            fields.push(Object.assign(err, { message: formatError(err.message) }));

            return true;
          }

          return false;
        });

        resolve(formatedErrors);
      });
  });

export default (data, noScroll = false) =>
  new Promise(resolve => {
    const promises = [];

    for (const key in data) {
      if (!data.hasOwnProperty(key)) {
        continue;
      }

      promises.push(validateObject(data[key], schemas[key]));
    }

    const formErrors = [];

    Promise.all(promises).then(results => {
      for (const result of results) {
        formErrors.push(...result);
      }

      // Scroll to first error
      if (!noScroll) {
        const offsets = formErrors.map(err => {
          const elem = document.getElementById(`input_${err.path}`);
          return documentOffsetTop(elem);
        });

        window.scrollTo(0, Math.min.apply(Math, offsets) - 99);
      }

      resolve(formErrors);
    });
  });



// WEBPACK FOOTER //
// ./src/utils/formValidation.js